var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHojaverde(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 91,
    viewBox: "0 0 71 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.225 0.0410156C31.1621 0.286977 30.1182 0.654118 29.1118 1.14244C11.7162 9.58366 0.56665 33.1885 0.56665 53.417C0.56665 72.6382 14.4675 88.4284 32.225 90.1732V0.0410156Z",
    fill: "#3BAF29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.775 90.1732C56.5324 88.4284 70.4333 72.6382 70.4333 53.417C70.4333 51.5764 70.341 49.7078 70.1601 47.8253L38.775 80.4083V90.1732Z",
    fill: "#3BAF29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.834 23.1477C61.1356 19.8618 59.1771 16.7489 56.9838 13.9044L38.775 32.8082V48.1249L62.834 23.1477Z",
    fill: "#3BAF29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5668 8.87333C49.3562 5.67625 45.7784 3.03017 41.8881 1.14244C40.8818 0.654118 39.8379 0.286977 38.775 0.0410156V23.1916L52.5668 8.87333Z",
    fill: "#3BAF29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7891 29.6964L38.775 57.7416V70.7916L68.25 40.1916L68.826 39.5936C68.0666 36.2493 67.0475 32.9247 65.7891 29.6964Z",
    fill: "#3BAF29"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHojaverde);
export default __webpack_public_path__ + "static/media/hojaverde.79bf101e5f718e6e424cd0bdb28cc3a2.svg";
export { ForwardRef as ReactComponent };